export default "/images/vendor/flag-icon-css/flags/1x1/gg.svg?30f47622e942430014e8123ba7e1cfee";